import React, { useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { Switch } from '@mui/material'
import ConfigureSplitCodDialog from 'src/components/rto-suite/ConfigureSplitCodDialog'
import { useRtoSuiteContext } from 'src/lib/contexts/RTOSuiteProvider'
import { useRTOSuitePermissions } from 'src/lib/access-permission-hooks/useRTOSuitePermissions'
import { classNames } from 'src/lib/utils/helpers'

const SplitCOD = () => {
  const { t } = useLocale()
  const { canEditRTOSuite } = useRTOSuitePermissions()

  const [openSplitConfig, setOpenSplitConfig] = useState<boolean>(false)

  const splitCodConfig = useRtoSuiteContext(context => context?.state?.splitCodConfig)
  const setSplitCod = useRtoSuiteContext(context => context?.actions?.setSplitCodConfig)

  const getSplitDescription = () => {
    const slabs = splitCodConfig?.slabs || []
    if (slabs.length > 1) {
      return t('split_cod.split_cod_multiple_slabs_configured') || 'Multiple Split COD rules configured'
    }

    const slab = slabs[0]
    const minOv = slab?.minOrderValue
    const splitValue = slab?.prepaidShare
    return t('split_cod_description', {
      amount:
        slab?.prepaidShareType === 'FLAT'
          ? t('split_cod_amount_in_rupee', { amount: splitValue || 0 })
          : t('split_cod_amount_in_percentage', { amount: splitValue || 0 }),
      minOv: minOv || 0
    })
  }

  return (
    <div className='pb-4'>
      <div className='flex flex-row justify-between pb-3' data-track-id='split-cod-header'>
        <div className='flex flex-col gap-1 text-sm'>
          <h2 className='font-medium text-carbon'>{t('rto_suite_split_cod_header')}</h2>
          <p className='font-normal leading-5 text-gray-dark'>{t('rto_suite_split_cod_subheader')}</p>
        </div>
        <Switch
          name='Toggler'
          disabled={!canEditRTOSuite}
          checked={splitCodConfig?.isEnabled}
          onChange={() => {
            setSplitCod({ ...splitCodConfig, isEnabled: !splitCodConfig?.isEnabled })
          }}
        />
      </div>
      <div id='split-cod-config'>
        <div className='flex items-center justify-between p-2 border rounded border-gray-light'>
          <p className='text-text-sm-regular pl-4 font-medium text-gray-dark'>{getSplitDescription()}</p>
          <button
            id='split-cod-edit-btn'
            className={classNames(
              'font-semibold h-9 rounded-lg py-2 px-3 text-sm border-2 whitespace-nowrap',
              splitCodConfig?.isEnabled
                ? 'hover:ring-1 hover:ring-coal-lighter transition-all duration-200'
                : 'opacity-50 !cursor-not-allowed'
            )}
            onClick={() => {
              if (!splitCodConfig?.isEnabled) return
              setOpenSplitConfig(true)
            }}
            disabled={!canEditRTOSuite}
          >
            {t('edit_rules')}
          </button>
        </div>
      </div>

      <ConfigureSplitCodDialog openSplitConfig={openSplitConfig} setOpenSplitConfig={setOpenSplitConfig} />
    </div>
  )
}

export default SplitCOD
